import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function LuxuryGatwickAirportChauffeurTransfer() {
  return <section data-section-id="244776" id="esperienze-elite" className="relative w-full h-[90svh] min-h-[600px] flex items-center justify-center bg-background overflow-hidden dark">
      {}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_elite_night_view.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_elite_night_view.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673241/img/yacht_elite_night_view.png-wvc-sizes" alt="Superyacht illuminato di notte a Ibiza" className="absolute inset-0 w-full h-full object-cover object-center" loading="eager" decoding="async" />

      {}
      <div className="absolute inset-0 bg-black/75" aria-hidden="true" />

      {}
      <div className="relative z-10 flex flex-col items-center text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto mt-16">
        <span className="inline-block py-1 px-3 rounded-md bg-secondary/10 border border-secondary/40 text-secondary font-medium text-sm tracking-widest uppercase mb-6 shadow-md backdrop-blur-md">
          Collection Gold
        </span>
        
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold font-default text-white mb-6 tracking-tighter drop-shadow-2xl">
          Il Vertice del <br className="hidden sm:block" />
          <span className="text-secondary">Lusso Nautico</span>
        </h1>
        
        <p className="text-lg sm:text-xl md:text-2xl text-white/80 mb-10 max-w-3xl font-default font-light leading-relaxed drop-shadow-lg">
          Esperienze esclusive e superyacht di prestigio. La nostra consulenza d'élite garantisce massima privacy e servizi su misura a Ibiza.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 bg-primary hover:bg-primary/90 text-white shadow-xl border-b-2 border-secondary/50">
            <Link to="/ContactsPage">
              <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
              Richiedi Preventivo
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 bg-transparent text-white border-white/30 hover:bg-white/5 hover:text-secondary hover:border-secondary backdrop-blur-sm transition-all duration-500">
            <Link to="/CollectionGoldPage">
              Esplora la Flotta
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}